
import React from 'react';
import { useNavbarCollapsed } from 'components/Dashboard/State';


export default function AppLogo({width=100, height=49}) {
  const { navbarCollapsed } = useNavbarCollapsed();
  if (navbarCollapsed) {
    return null;
  }

  return (
    <svg width={width} height={height} viewBox="0 0 100 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.8486 35.5189H25.1615L27.2526 19.4563C21.9459 21.0641 17.5194 23.1298 14.1817 25.3125L12.8486 35.5189Z" fill="#333333"/>
      <path d="M46.0119 17.2481H51.5832L52.5347 9.92149H46.9685L48.2557 0.0101929C42.949 1.61798 38.5225 3.68368 35.1848 5.8664L34.6913 9.92149H30.3055L29.354 17.2481H33.7042L32.5492 26.1419C31.959 30.6854 32.3254 36.1091 41.4633 36.1091C45.3708 36.1091 47.925 35.2798 49.3038 34.7914L50.2654 27.4138C48.795 27.8056 48.1997 27.9023 47.4671 27.9023C44.6331 27.9023 44.9791 25.2667 45.0707 24.529L46.0119 17.2481Z" fill="#333333"/>
      <path d="M99.9999 0.183228C94.7135 1.78593 90.3124 3.84145 86.9849 6.014L83.0417 35.3511L95.1917 35.346L99.9999 0.183228Z" fill="#333333"/>
      <path d="M27.1916 11.4377L28.3364 11.1273L28.4941 9.92151H16.1813L15.4385 15.6454C19.0051 14.0122 22.9483 12.5825 27.1916 11.4377Z" fill="#333333"/>
      <path d="M16.5273 7.23505H28.8402L29.7814 0C24.4747 1.60779 20.0482 3.6735 16.7105 5.85622L16.5273 7.23505Z" fill="#FEC108"/>
      <path d="M72.9221 9.95203L67.5695 26.7015H67.4729L66.4705 9.95203H54L58.2179 35.4629L73.787 35.4579L84.782 9.95203H72.9221Z" fill="#333333"/>
      <path d="M69.9167 18.9393C69.4217 17.1379 68.3201 15.5945 66.7332 14.3143L67.4514 26.823L67.0826 20.3814L67.0632 20.3663C67.5291 27.7592 55.9841 37.1154 40.1007 41.8821C23.2419 46.9423 7.88745 44.9132 5.80072 37.3533C3.91296 30.5119 13.541 21.4795 27.8812 16.0752L28.1772 13.7374C10.2411 19.754 -2.09974 31.1495 0.297576 39.8328C2.80165 48.9006 20.4127 51.5673 39.6348 45.7987C58.8619 40.0301 72.4159 28.0071 69.9167 18.9393Z" fill="#FEC108"/>
    </svg>
  )
}
